import { Component, ViewEncapsulation, AfterViewChecked,OnInit, ElementRef,ViewChild} from '@angular/core';
import {Router,ActivatedRoute} from '@angular/router';
import { Observable } from 'rxjs/Observable'; 
import { NgForm } from '@angular/forms';
import {userlist,chatData,showChat} from '../chat';
import {Store} from '@ngrx/store';
import {AngularFireAuth} from 'angularfire2/auth';
import {AngularFireDatabase, FirebaseObjectObservable, FirebaseListObservable} from 'angularfire2/database';

@Component({
  selector: 'app-chat-box',
  templateUrl: './chat-box.component.html',
  styleUrls: ['./chat-box.component.scss']
})
export class ChatBoxComponent implements OnInit,AfterViewChecked{
  @ViewChild('scrollMe') private myScrollContainer: ElementRef;

    public chatList:Array<any>;
    username:any='';
     chatMessage={
    	message:'',
    	sendBy:'Admin',
    	createdAt:Date.now()
    }
   public imageUrl:any;
   public chatData:any=[];
   messageId: Observable<string>;
   chatUserId:any;
   public isLoading: boolean = false;
   public user:any={};
    constructor( public el: ElementRef,
                 private routes: ActivatedRoute,
                 public af:AngularFireAuth,
    	        public db:AngularFireDatabase,
                 private router: Router,
                 public storeData:Store<showChat>) {
                
       this.messageList();
     }

   messageList(){
         this.messageId = this.storeData.select('data');

         this.messageId.subscribe(res=>{
         if(res != '@ngrx/store/init'){
             this.chatUserId = res;

            this.db.object('/messages/'+this.chatUserId).subscribe(response=>{
            	console.log(JSON.stringify(response)+"res");
            this.username = response.name
            this.imageUrl = response.imageUrl


            }) 
             this.db.list('/messages/'+this.chatUserId).subscribe(response=>{
            //	console.log(JSON.stringify(response)+"res");
             this.chatData = response;
             
            console.log("chat msg"+JSON.stringify(response));
            }) 

           
         }
      })
   }

   ngOnInit() { 
        this.scrollToBottom();
    }

    ngAfterViewChecked() {        
        this.scrollToBottom();        
    } 

    scrollToBottom(): void {
        try {
            this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        } catch(err) { }                 
    }

  /* scrollToBottom() {
    let scrollPane: any = this.el
      .nativeElement.querySelector('.msg-container-base');   
    scrollPane.scrollTop = scrollPane.scrollHeight;
  }*/


   //send Message
     sendMessage(form:NgForm){
  	this.db.list('/messages/'+this.chatUserId).push(this.chatMessage).then(res=>{
  		this.chatMessage={
    	message:'',
    	sendBy:'Admin',
    	createdAt:Date.now()
    }
  	})
  }

}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/chat/chat-box/chat-box.component.ts